import { useEffect, useState } from "react";


const useDate = (AccessExpireTime) => {
    const [today, setDate] = useState(new Date()); // Save the current date to be able to trigger an update
    
    useEffect(() => {
        const timer = setInterval(() => { // Creates an interval which will update the current data every minute
        // This will trigger a rerender every component that uses the useDate hook.
        setDate(new Date());
      },1000);
      return () => {
        clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
      }
    }, []);
  
    const shamsiDateRaw = today.toLocaleString("fa-IR").split(",");
    const dateRaw = today.toLocaleString("en-US").split(",");
    const time = shamsiDateRaw[1]?.trim();
    const date = shamsiDateRaw[0];
    const refreshtime=today
    
    return [ dateRaw, time, date,refreshtime ];
  };
  export default useDate;